import { useEffect, useSyncExternalStore } from 'react';
import {
  subscribe,
  getState,
  ensureSessionChecked,
  login,
  logout,
  changePassword,
} from '../auth/authStore';

// Multi-user session auth. Access control is enforced by the backend
// (AUTH_MODE=session); this hook mirrors session state into React and exposes
// login/logout/changePassword. On first mount it probes /api/me once.
export const useAuth = () => {
  const state = useSyncExternalStore(subscribe, getState, getState);

  useEffect(() => {
    void ensureSessionChecked();
  }, []);

  return {
    user: state.user,
    isAuthenticated: state.status === 'authenticated',
    isLoading: state.status === 'loading',
    mustChangePassword: state.user?.must_change_password ?? false,
    userDisplayName: state.user?.name || state.user?.email || 'Beyond Borders',
    login,
    changePassword,
    handleLogout: logout,
  };
};
